import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../CommonStyles/reset.scss";
import history from "../Utils/history";
import AppRouter from "../routes";
import { ThemeProvider } from "@material-ui/core/styles";
import { ThemeProvider as ThemeProviderV5 } from "@mui/material/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import theme from "../theme";
import { RootState } from "../Redux/Reducers";
import { checkStaffInvite, fetchRestrictionConfig } from "../Redux/Actions";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import "@dotpe/additional-pages/dist/styles/index.scss";
import { BUY_SUBSCRIPTION } from "../Constants/routesConstant";
import { getAuthToken } from "../Utils/authToken";
import { getLoginUrl, clevertapEventPush, getUrlParams } from "../Utils/common";
import { useCheckLoginStatus } from "./hooks/useCheckLoginStatus";
import { useRenderFBAds } from "./hooks/useRenderFBAds";
import { useMobileSpecificMethods } from "./hooks/useMobileSpecificMethods";
import { useUploadTimers } from "./hooks/useUploadTimers";
import { useOpenRouteMethods } from "./hooks/useOpenRouteMethods";
import { useCheckEmailVerification } from "./hooks/useCheckEmailVerification";
import { themeV5 } from "./../theme";
import { GlobalModalsContainer } from "./GlobalModalsContainer";

const App = (): JSX.Element => {
  const dispatch = useDispatch();
  const [showStaffInvitationModal, setShowStaffInvitationModal] = useState(false);
  const { staffInvitationData, storeData } = useSelector((state: RootState) => ({
    staffInvitationData: state.staffManagementReducer.staffInvitationData,
    storeData: state.storeReducer.store,
  }));
  const isWebview = window.location.pathname.startsWith("/webview");

  useCheckLoginStatus();
  useOpenRouteMethods();
  useRenderFBAds();
  useMobileSpecificMethods();
  useUploadTimers();
  useCheckEmailVerification();

  useEffect(() => {
    if (isWebview) {
      return;
    }

    if (storeData?.store_id && getAuthToken()) {
      dispatch(fetchRestrictionConfig({ storeId: storeData?.store_id }));
    }
  }, [storeData?.store_id]);

  useEffect(() => {
    if (isWebview) {
      return;
    }
    const { code: instaConnectCode } = getUrlParams(["code"]);
    if (instaConnectCode) {
      localStorage.setItem("instaCode", instaConnectCode as string);
      window.close();
      return;
    }

    if (window.location.pathname !== BUY_SUBSCRIPTION) {
      const callback = (response: any) => {
        if (response?.is_invitation_available) {
          setShowStaffInvitationModal(true);
        } else if (getAuthToken()) {
          dispatch(checkStaffInvite(callback));
          clevertapEventPush("App_Launched");
          if (
            !["/domain-completion"].includes(window.location.pathname) &&
            (history.location.pathname.includes("/login") || history.location.pathname === "/")
          ) {
            history.push(`/orders${getLoginUrl()}`);
          }
        } else {
          if (
            ![BUY_SUBSCRIPTION, "/domain-sale", "/domain-completion", "/domain-open-search", "/payment"].includes(
              window.location.pathname,
            )
          ) {
            // add window.location.search to accomodate search params for create store in onboarding page
            // if window.location.search is "" then nothing happens
            history.push(`/${window?.location?.search || ""}`);
          }
        }
      };
    }
  }, []);

  useEffect(() => {
    if (
      window.location.pathname !== BUY_SUBSCRIPTION &&
      staffInvitationData?.is_invitation_available &&
      !showStaffInvitationModal &&
      !(history.location.pathname.includes("/login") || history.location.pathname === "/")
    ) {
      setShowStaffInvitationModal(true);
    }
  }, [staffInvitationData]);

  return (
    <ThemeProvider theme={theme}>
      <ThemeProviderV5 theme={themeV5}>
        <CssBaseline />
        <AppRouter />
        <GlobalModalsContainer />
      </ThemeProviderV5>
    </ThemeProvider>
  );
};

export default App;
